export default __webpack_public_path__ + "static/media/mt.55fb019d.svg";